import {actionTypes} from "./actions";
import {AllIdState, ByIdState} from "./reducer";
import {AOIMonitor as Notification} from "./model";

const loadNotificationsSuccessForNotificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    const loadedNotifications = action.payload;
    const nextState: ByIdState = Object.assign({}, state);
    loadedNotifications.forEach((aNotification) => {
        nextState[aNotification.id] = aNotification;
    });
    return nextState;
};

const loadNotificationsSuccessForAllIdReducer = (state: AllIdState = [], action): AllIdState => {
    const loadedNotifications = action.payload;
    return loadedNotifications.map((notification) => notification.id);
};

const loadNotificationDetailForNotificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    const loadedNotification = action.payload;
    return Object.assign({}, state, {[loadedNotification.id]: loadedNotification});
};

const updateNotificationActionForNotificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    let updatedNotification = action.payload.notification;
    if (state[action.payload.notification.id]) {
        //the redux state might already contain a more detailed view on the notification, merge it with the less-detailed notification coming from the server
        updatedNotification = Object.assign({}, state[action.payload.notification.id], action.payload.notification);
    }
    return Object.assign({}, state, {[action.payload.notification.id]: updatedNotification});
};

const deleteNotificationForNotificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    const deletedState: ByIdState = Object.assign({}, state);
    delete deletedState[action.payload.id];
    return deletedState;
};

const updateNotificationForNotificationByIdReducer = (state: ByIdState = {}, action): ByIdState => {
    const notification = state[action.payload.id];
    if (notification) { //only update a notification if it's already present
        return Object.assign({}, state, {
            [notification.id]: notificationReducer(notification, action),
        });
    }
    return state;
};

const addNotificationForAllIdReducer = (state: AllIdState = [], action): AllIdState => {
    return [...state, action.payload.notification.id];
};

const removeNotificationForAllIdReducer = (state: AllIdState = [], action): AllIdState => {
    const removedId = action.payload.id;
    return state.filter((id) => id !== removedId);
};

const notificationReducer = (state: Notification, action) => {
    if (action.type === actionTypes.PROGRESS_NOTIFICATION) {
        return Object.assign({}, state, {progress: action.payload.progress});
    }
    return state;
};

export const notificationReducerUtil = {
    loadNotificationsSuccessForNotificationByIdReducer,
    loadNotificationsSuccessForAllIdReducer,
    loadNotificationDetailForNotificationByIdReducer,
    updateNotificationActionForNotificationByIdReducer,
    deleteNotificationForNotificationByIdReducer,
    updateNotificationForNotificationByIdReducer,
    addNotificationForAllIdReducer,
    removeNotificationForAllIdReducer,
};